import reducer from './reducer'

import * as accrualsTableOperations from './operations'
import * as accrualsTableSelectors from './selectors'

export { accrualsTableOperations, accrualsTableSelectors }

export default reducer
